"use client";

import useAppMessage from "@lib/user/useAppMessage";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Link, styled } from "@mui/material";

const Banner = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.success.main,
  padding: "7px 16px",
  borderRadius: "4px",
  border: `1px solid ${theme.palette.success.border}`,
  margin: "40px 46px 0",
}));

const Emoji = styled("span")({
  fontSize: "1.5rem",
  marginRight: "10px",
});

const Message = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  columnGap: "10px",
  fontSize: "0.9rem",
});

const DismissButton = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.main,
  lineHeight: "1rem",
}));

export default function AppMessageBanner() {
  const { message, dismissMessage } = useAppMessage();

  if (!message) {
    return null;
  }

  return (
    <Banner>
      <Emoji>🎉</Emoji>
      <Message>
        <strong>{message.primary}</strong>
        {message.secondary}
      </Message>
      <DismissButton href="#" onClick={dismissMessage}>
        <CloseIcon />
      </DismissButton>
    </Banner>
  );
}
